import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import Img from "@/components/img";
import { ourPolicyCertificate } from "@/data";
import SwiperCore, { Autoplay, Navigation, Thumbs } from "swiper";

SwiperCore.use([Autoplay, Thumbs, Navigation]);

const AboutOurPolicy = () => {

    const { certificate, title, paragraph1, paragraph2 } = ourPolicyCertificate

    const policyCertificateSwiperOptions = {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: false,
        speed: 1000,
        navigation: {
            nextEl: "#our-policy-slide-Next",
            prevEl: "#our-policy-slide-Prev",
        },
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        },
    };

    return (
        <section className="aboutOurPolicySection" id="quality-policy">
            <div className="container">
                <div className="ourPolicyMainContainer">
                    <div className="ourPolicyLeftSection">
                        <h1 className="titleHeader">{title}</h1>
                        <p className="ourPolicyParagraph1">{paragraph1}</p>
                        <p className="ourPolicyParagraph2">{paragraph2}</p>
                    </div>
                    <div className="ourPolicyRightSection">
                        <Swiper {...policyCertificateSwiperOptions} className="ourPolicySlider">
                            {certificate.map(({ image }, index) => (
                                <SwiperSlide key={`our-policy-key-${index}`}>
                                    <div className="ourPolicyImages">
                                        <Img src={image} alt={title} className="imgCertificates" />
                                    </div>
                                </SwiperSlide>
                            ))}
                            <div className="swiper-button-prev" id="our-policy-slide-Prev">
                                <i className="fa fa-angle-left sliderIconPrev"></i>
                            </div>
                            <div className="swiper-button-next" id="our-policy-slide-Next">
                                <i className="fa fa-angle-right sliderIconNext"></i>
                            </div>
                        </Swiper>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default AboutOurPolicy